export const LOGIN_URL = "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/login";

export const ASSESSMENTTABLE_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/homepage-assessments";

export const ASSESSMENTPOPUP_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/attr_breakdown";

export const UPLOADEXCEL_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/uploadexcel";

export const LOOKER_FLAG = false;

export const NEWASSESSMENTPOPUP_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/assessments";

export const TARGETSCENARIO_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/assessments";

export const SUBMIT_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/assessments";

export const SAVEWORKSPACEDATA_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/assessments";

export const WORKSPACESUBMITREVIEWAL_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/assessments";
export const GETWORKSPACEDATA_URL =
  "https://lca-be-2v3rjq55.ts.gateway.dev/api/v1/assessments";
